import * as React from 'react'

import { Box, CollapsableCard, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import useUpdateAttendanceSetting from 'modules/attendance/components/SettingItemPage/TimeTracking/hooks/useUpdateAttendanceSetting'
import AttendanceSettingForm from 'modules/attendance/lib/forms/AttendanceSettingForm'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

interface Props {
  attendanceSetting: AttendanceSetting
}

const createSettingForm = (setting: AttendanceSetting) =>
  new AttendanceSettingForm({
    edit_timesheet_authorization: setting.attributes.edit_timesheet_authorization,
  })

const EditTimesheetAuthorization = ({ attendanceSetting }: Props) => {
  const [settingForm, setSettingForm] = React.useState(createSettingForm(attendanceSetting))
  const editTimesheetAuthorizationField = settingForm.get('edit_timesheet_authorization')
  const { updateSetting } = useUpdateAttendanceSetting(settingForm, attendanceSetting)

  useEffect(() => {
    setSettingForm(createSettingForm(attendanceSetting))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attendanceSetting.attributes.id])

  const onChange = (newValue: boolean) => {
    track(trackingEvents.timeTracking.toggleShiftEditRestriction, { toggle_enabled: newValue })
    editTimesheetAuthorizationField.set(newValue)
    updateSetting()
  }

  return (
    <CollapsableCard
      open={false}
      Card={
        <Box
          gap="s8"
          extra={{ 'data-intercom-target': 'attendance-timesheet-edit-timesheet-authorization' }}
        >
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="medium">
              {i18n.t('time_tracking.settings.timesheet_approvals.edit_timesheet.title')}
            </Text.Normal>
            <TogglerCheckbox
              value={editTimesheetAuthorizationField.value}
              onChange={(newValue) => onChange(newValue)}
              labelBefore
            />
          </Box>
          <Text.Normal>
            {i18n.t('time_tracking.settings.timesheet_approvals.edit_timesheet.description')}
          </Text.Normal>
        </Box>
      }
      Content={<></>}
    />
  )
}

export default observer(EditTimesheetAuthorization)
